var React = require('react');

function Time (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24 14.521c.78 0 1.412.632 1.412 1.412v7.482l9.67 9.672a1.412 1.412 0 11-1.997 1.996L23.01 25.006a1.414 1.414 0 01-.422-1.002v-8.071c0-.78.632-1.412 1.412-1.412z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 24C0 10.745 10.745 0 24 0s24 10.745 24 24-10.745 24-24 24S0 37.255 0 24zM24 2.824C12.305 2.824 2.824 12.304 2.824 24c0 11.696 9.48 21.176 21.176 21.176 11.696 0 21.176-9.48 21.176-21.176 0-11.695-9.48-21.176-21.176-21.176z","key":1})]);
}

Time.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Time;

Time.default = Time;
